import { Container } from "./styles";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import k8s from "../../assets/icons8-kubernetes.svg";
import docker from "../../assets/icons8-docker.svg";
import git from "../../assets/icons8-git.svg";
import next from "../../assets/icons8-nextjs.svg";
import pythonIcon from "../../assets/python-svgrepo-com.svg";
import azureIcon from "../../assets/azure-svgrepo.svg";
import mongoIcon from "../../assets/mongo.png";
import chromaIcon from "../../assets/croma.png";
import microsoftIcon from "../../assets/microsoft-svgrepo-com.svg";
import fastApiIcon from "../../assets/fastapi-icon.svg";
import githubIcon from "../../assets/github-color-svgrepo-com.svg";
import mysqlIcon from "../../assets/mysql-icon.svg";
import tailwindIcon from "../../assets/icons8-tailwind-css.svg";
import nodeIcon from "../../assets/node-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function Expertise() {
  return (
    <Container id="expertise">
      <ScrollAnimation animateIn="fadeInUp">
        <h2>My Tech Stack</h2>
      </ScrollAnimation>
      
      <div className="skills-grid">
        <ScrollAnimation animateIn="fadeInUp" delay={0.10 * 1000}>
          <div className="skill-item">
            <img src={pythonIcon} alt="Python" />
            <span className="tech-name">Python</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
          <div className="skill-item">
            <img src={fastApiIcon} alt="FastAPI" />
            <span className="tech-name">FastAPI</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
          <div className="skill-item">
            <span className="tech-icon">🦜</span>
            <span className="tech-name">LangChain</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
          <div className="skill-item">
            <img src={microsoftIcon} alt="AutoGen" />
            <span className="tech-name">AutoGen</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
          <div className="skill-item">
            <img src={azureIcon} alt="Azure" />
            <span className="tech-name">Azure</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.20 * 1000}>
          <div className="skill-item">
            <img src={chromaIcon} alt="ChromaDB" />
            <span className="tech-name">ChromaDB</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.22 * 1000}>
          <div className="skill-item">
            <img src={mysqlIcon} alt="MySQL" />
            <span className="tech-name">MySQL</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.24 * 1000}>
          <div className="skill-item">
            <img src={mongoIcon} alt="MongoDB" />
            <span className="tech-name">MongoDB</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.26 * 1000}>
          <div className="skill-item">
            <img src={githubIcon} alt="GitHub" />
            <span className="tech-name">GitHub</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.28 * 1000}>
          <div className="skill-item">
            <img src={reactIcon} alt="React" />
            <span className="tech-name">React</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.30 * 1000}>
          <div className="skill-item">
            <img src={next} alt="Next.js" />
            <span className="tech-name">Next.js</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.32 * 1000}>
          <div className="skill-item">
            <img src={typescriptIcon} alt="TypeScript" />
            <span className="tech-name">TypeScript</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.34 * 1000}>
          <div className="skill-item">
            <img src={jsIcon} alt="JavaScript" />
            <span className="tech-name">JavaScript</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.36 * 1000}>
          <div className="skill-item">
            <img src={nodeIcon} alt="Node.js" />
            <span className="tech-name">Node.js</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.38 * 1000}>
          <div className="skill-item">
            <img src={tailwindIcon} alt="Tailwind CSS" />
            <span className="tech-name">Tailwind</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.40 * 1000}>
          <div className="skill-item">
            <img src={docker} alt="Docker" />
            <span className="tech-name">Docker</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.42 * 1000}>
          <div className="skill-item">
            <img src={k8s} alt="Kubernetes" />
            <span className="tech-name">Kubernetes</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.44 * 1000}>
          <div className="skill-item">
            <img src={git} alt="Git" />
            <span className="tech-name">Git</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.46 * 1000}>
          <div className="skill-item">
            <img src={htmlIcon} alt="HTML" />
            <span className="tech-name">HTML</span>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.48 * 1000}>
          <div className="skill-item">
            <img src={cssIcon} alt="CSS" />
            <span className="tech-name">CSS</span>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}
